import type { WorkflowInstanceView } from "@ncp/api-client";

/** Localised label of a workflow state key, or the key itself when the definition does not know it. */
export function stateLabel(workflow: WorkflowInstanceView | undefined, state: string, locale: string): string {
  const node = workflow?.definition.nodes.find((n) => n.key === state);
  if (!node) return state;
  return locale === "ar" ? node.labelAr : node.label;
}
